var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Suspense, useEffect, useState, } from 'react';
import { HashRouter as Router, Routes, Route, } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Summary } from './Components/Summary';
import { Address } from './Components/Address';
import { ProductCard } from './Components/ProductCard';
import { PaymentSelection } from './Components/PaymentSelection';
import { Complete } from './Components/Complete';
import { AmountDependentData } from './Components/AmountDependentData';
import { loadingSpinner } from './Components/Ui/SpinnerButton/SpinnerButton';
import { Progressbar } from './Components/Progressbar';
import { Terms } from './Components/Terms';
import { ErrorInformation } from './Components/Ui/ErrorInformation/ErrorInformation';
import { appProductState, appConfigState, useSetAppErrors, useProgress, appOrderState, appProgressState, resetAppState, } from './Domain/State/AppState';
import { OrderService } from './Domain/OrderService';
import { AppServiceContext } from './Domain/Context/AppServiceContext';
import { PaymentService } from './Domain/PaymentService';
import { ProductService } from './Domain/ProductService';
import { ShipmentService } from './Domain/ShipmentService';
import { ShopService } from './Domain/ShopService';
import { ShipmentSelection } from './Components/ShipmentSelection';
export function App(props) {
    var _this = this;
    var _a = useState(undefined), appServiceConfig = _a[0], setAppServiceConfig = _a[1];
    var _b = useRecoilValue(appProgressState), orderCompleted = _b.orderCompleted, steps = _b.steps;
    var _c = useRecoilState(appOrderState), order = _c[0], setOrder = _c[1];
    var _d = useRecoilState(appProductState), product = _d[0], setProduct = _d[1];
    var _e = useRecoilState(appConfigState), shopUri = _e[0].shopUri, setConfig = _e[1];
    var resetApp = useSetRecoilState(resetAppState);
    var _f = useProgress(), setSteps = _f.setSteps, addStep = _f.addStep;
    var _g = useSetAppErrors(), updateErrorMessage = _g.updateErrorMessage, resetErrorMessage = _g.resetErrorMessage;
    var _h = useState(true), isLoading = _h[0], setIsLoading = _h[1];
    useEffect(function () {
        function needsReset(productCode, productVariantCode) {
            if (order && order.checkoutState === 'completed')
                return true;
            if (product.productCode && product.productVariantCode) {
                if (product.productCode !== productCode
                    || product.productVariantCode !== productVariantCode) {
                    return true;
                }
            }
            return false;
        }
        var productCode = props.productCode, productVariantCode = props.productVariantCode, otherProps = __rest(props, ["productCode", "productVariantCode"]);
        if (needsReset(productCode, productVariantCode)) {
            resetApp(null);
        }
        if (!props.shopUri || props.shopUri === '') {
            updateErrorMessage('Es wurde keine Uri für die Anbindung an das Shop System übergeben.');
        }
        // We wrap all the logic in an async function to be able to use await for the order
        // and to keep synchronous execution
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var services, newOrder, _a, syliusProductVariant, _b, syliusProduct, productAttributes, formSchemaJson, unitLabel, billingPlanLabel, summaryTotalLabel;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setConfig(otherProps);
                        if (steps.length > 0) {
                            setSteps(steps, orderCompleted || needsReset(productCode, productVariantCode));
                        }
                        else {
                            setSteps([], true);
                        }
                        services = {
                            orderService: new OrderService(props.shopUri),
                            productService: new ProductService(props.shopUri),
                            paymentService: new PaymentService(props.shopUri),
                            shipmentService: new ShipmentService(props.shopUri),
                            shopService: new ShopService(props.shopUri),
                        };
                        setAppServiceConfig(services);
                        if (!(!order || Object.keys(order).length === 0 || order.checkoutState === 'completed' || needsReset(productCode, productVariantCode) || orderCompleted)) return [3 /*break*/, 2];
                        return [4 /*yield*/, services.orderService.getOrder()];
                    case 1:
                        newOrder = _c.sent();
                        setOrder(newOrder);
                        _c.label = 2;
                    case 2: return [4 /*yield*/, Promise.all([
                            services.productService.getProductVariant(productVariantCode),
                            services.productService.getProductAttributes(productCode),
                        ])
                            .catch(function () {
                            updateErrorMessage('Es ist ein Fehler aufgetreten - bitte kontaktieren Sie uns.');
                            return [];
                        })];
                    case 3:
                        _a = _c.sent(), syliusProductVariant = _a[0], _b = _a[1], syliusProduct = _b.product, productAttributes = _b.attributes;
                        formSchemaJson = productAttributes.amount_dependent_data, unitLabel = productAttributes.unit_label, billingPlanLabel = productAttributes.billing_plan_label, summaryTotalLabel = productAttributes.summary_total_label;
                        if (formSchemaJson && formSchemaJson !== '') {
                            addStep({
                                label: 'Zusatzinformationen',
                                route: '/additional',
                                completed: false,
                            }, 2);
                        }
                        setProduct({
                            syliusProduct: syliusProduct,
                            syliusProductVariant: syliusProductVariant,
                            productCode: productCode,
                            productVariantCode: productVariantCode,
                            unitLabel: unitLabel,
                            billingPlanLabel: services.productService.replacePricePlaceholder(billingPlanLabel, syliusProductVariant.price),
                            summaryTotalLabel: summaryTotalLabel,
                            formSchemaJson: (formSchemaJson && formSchemaJson !== '') ? JSON.parse(formSchemaJson) : '',
                        });
                        resetErrorMessage();
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    return (_jsx(_Fragment, { children: _jsxs(AppServiceContext.Provider, __assign({ value: appServiceConfig }, { children: [_jsx(ErrorInformation, { title: "Es ist ein Fehler aufgetreten." }), shopUri && shopUri !== '' && !isLoading && order
                    ? _jsxs(Router, __assign({ basename: 'checkout' }, { children: [_jsx(Progressbar, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Suspense, __assign({ fallback: loadingSpinner({ class: 'blue' }) }, { children: _jsx(ProductCard, {}) })) }), _jsx(Route, { path: "/additional", element: _jsx(AmountDependentData, {}) }), _jsx(Route, { path: "/address", element: _jsx(Suspense, __assign({ fallback: loadingSpinner({ class: 'blue' }) }, { children: _jsx(Address, {}) })) }), _jsx(Route, { path: "/shipment", element: _jsx(ShipmentSelection, {}) }), _jsx(Route, { path: "/payment", element: _jsx(PaymentSelection, {}) }), _jsx(Route, { path: "/terms", element: _jsx(Terms, {}) }), _jsx(Route, { path: "/summary", element: _jsx(Summary, {}) }), _jsx(Route, { path: "/complete", element: _jsx(Complete, {}) })] })] }))
                    : _jsx(_Fragment, { children: loadingSpinner({ class: 'blue' }) })] })) }));
}
